<template>
	<div id="header" >
		<header>
			<div class="logo">
				<!-- <span>LOGO</span>
				<span>LOGO</span> -->
				<img style="height:60px" src="../../assets/logo.jpg" alt="">
			</div>
			<div class="nav_box">
				<span v-for="item in $router.options.routes[0].children" v-if='item.name != ""' :key="item.name" v-bind:class="{ cur:item.path==current}">
					<router-link :to="item.path">
						<div>{{ item.name }}</div>
					</router-link>
				</span>
				<span v-if='name' v-bind:class="{ cur:current=='/myteam' ||current=='/mycenter' }">
					<router-link :to="center">
						<div>个人中心</div>
					</router-link>
				</span>
				<button v-if='!name' @click="login()">登录</button>
				<button v-if='name' @click="outlogin()">退出</button>
			</div>
		</header>
	</div>
</template>

<script>
	import Bus from '../../assets/Bus.js'
	export default {
		data() {
			return {
				current: '',
				name: '',
				center: '',
				islogin: 1,
			};
		},
		created() {

			this.current = this.$route.path
			var that = this
			var competition_info = JSON.parse(localStorage.getItem('competition_info'))
			if (competition_info) {
				this.name = competition_info.UserName
				if (competition_info.RegistType == 1) {
					that.center = '/myteam'
				} else {
					that.center = '/mycenter'
				}
			}

			Bus.$on("UserName", function(val) {
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				that.name = competition_info.UserName
				console.log(competition_info)
				if (competition_info.RegistType == 1) {
					that.center = '/myteam'
				} else {
					that.center = '/mycenter'
				}
			})
		},
		methods: {
			login() {
				console.log(1111);
				this.$emit('islogin', this.islogin)
			},
			outlogin() {
				this.$confirm('确认退出登录吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					localStorage.removeItem('competition_info')
					localStorage.removeItem('competition_cookie')
					localStorage.removeItem('LocalAnswerList')
					localStorage.removeItem('stem')
					this.name = ''
					this.center = ''
					console.log(this.$route.path);
					if(this.$route.path == '/mycenter' ||this.$route.path == '/myteam'){
						this.$router.push('/main')
					}
					this.$message({
						type: 'success',
						message: '登录已退出!'
					});
				}).catch(() => {

				});
			}
		},
		watch: {
			$route(to, from) {
				console.log(to.path);
				this.current = to.path
			}
		},
	}
</script>

<style scoped="scoped" lang="scss">
	$background:#3e1976;

	#header {
		width: 100%;
		height: 60px;
		line-height: 60px;
		background: $background;
		color: #fff;
		overflow: hidden;
		header {
			max-width: 1000px;
			margin: 0 auto;
			height: 60px;
			color: #fff;
			display: flex;
			justify-content:space-around;
			.logo {
				float: left;
			}

			.nav_box {
				float: right;
				color: #fff;
				display: flex;
				font-size: 14px;
				align-items: center;

				.cur {
					border-bottom: 4px solid #b58943;
					box-sizing: border-box;
					height: 60px;
				}

				span {
					padding: 0 10px;
					margin-left: 15px;
					white-space:nowrap;
				}

				button {
					background: #b58943;
					color: #fff;
					border: #b58943;
					padding: 5px 20px;
					border-radius: 5px;
					font-size: 14px;
					font-weight: bold;
					margin-left: 30px
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue